<div class="tabbable__body rounded-top-right no-margin">
  <h3 >Här kan du administrera fördelningen för regioner</h3>

  @if (totalSharesHaveChanged()) {
    <import-warning></import-warning>
  }

  <form #shareOfTotalForm="ngForm" (ngSubmit)="updateShareOfTotal()">
    <label>
      Andel av totallagret som ska vara tillgängligt för regionslagret
    </label>
    <div class="save-total-lager-container">
      <div class="lager-input input__container flex__container align-items--end">
        <input
          name="regionShareOfTotal"
          [(ngModel)]="shareOfTotal"
          wooPercentFormatter
          [wooMinValidator]="0"
          [wooMaxValidator]="1"
          required
        />
      </div>
      <div class="lager-button">
        <button
          class="button"
          type="submit"
          [disabled]="!shareOfTotalForm.valid"
        >
          Spara
        </button>
      </div>
    </div>

    <div class="divider margin-top-bottom--2x"></div>

    <div class="container">
      <div class="left-item">
        @if (isEditing()) {
          <button
            class="button primary"
            (click)="save()"
            [disabled]="regionForm.invalid"
          >
            Spara
          </button>
          <button class="link" (click)="cancelEditing()">
            Avbryt redigering
          </button>
        } @else {
          <button class="button primary" (click)="setEditing(true)">
            Redigera&nbsp;Estimatfördelning
          </button>
        }
      </div>
      <div class="right-item">
        <div class="display--flex">
          @if (productFormats?.length > 1) {
            <div class="dropdown filter-dropdown margin-left--2x">
              <woo-dropdown
                [items]="productFormats"
                [(ngModel)]="selectedProductFormat"
                name="selectedProductFormat"
                inputId="select-product-format"
                labelText="Filtrera på Placering"
                [labelTransform]="translateProductFormat"
                notFoundText="Inga Placeringar hittades."
                [clearable]="true"
              ></woo-dropdown>
            </div>
          }
        </div>
      </div>
    </div>
  </form>


  <div class="sticky-header">
    <h3>Tillgängliga regioner</h3>
  </div>

  <table
    class="table table-woo table--info table--hover width--100"
    ngForm
    #regionForm="ngForm"
  >
    <thead class="sticky-table-head">
      <tr>
        <th class="text--thin capitalize--first-letter">Regioner</th>

        @if (regionRows()?.length) {
          @for (
            productFormatId of regionRows()[0].productFormatIds;
            track productFormatId
          ) {
            <th
              [hidden]="!colVisible(productFormatId)"
              class="text--thin capitalize--first-letter"
            >
              {{ translateProductFormat(tableHeaders[productFormatId]) }}
            </th>
          }
        }
      </tr>
    </thead>

    @if (!loading()) {
      <tbody>
        @for (row of regionRows(); let rIdx = $index; track rIdx) {
          @if (rowVisible(row.regionId)) {
            <tr>
              <td class="text--thin vertical-align--middle">
                {{ row.regionName }}
              </td>

              @for (
                productFormatId of row.productFormatIds;
                let cIdx = $index;
                track cIdx
              ) {
                <td
                  [hidden]="!colVisible(productFormatId)"
                  class="text--thin vertical-align--middle"
                >
                  @if (!isEditing()) {
                    {{
                      getRegion(row.regionId).shares[productFormatId]
                        | percent: '1.0-3'
                    }}
                  } @else {
                    <div class="input__container">
                      <input
                        name="row-{{ rIdx }}-{{ cIdx }}-regionShare"
                        [(ngModel)]="
                          getRegion(row.regionId).shares[productFormatId]
                        "
                        wooPercentFormatter
                        [wooMinValidator]="0"
                        [wooMaxValidator]="1"
                        required
                      />
                    </div>
                  }
                </td>
              }
            </tr>
          }
        }

        <tr>
          <td class="vertical-align--middle"><strong>Totalt:</strong></td>

          @if (regionRows()?.length && sumOfProductFormatShares) {
            @for (
              productFormatId of regionRows()[0].productFormatIds;
              let index = $index;
              track index;
            ) {
              <td [hidden]="!colVisible(productFormatId)">
                <strong>{{ sumOfProductFormatShares(productFormatId) }}</strong
                > %
              </td>
            }
          }
        </tr>
      </tbody>
    }

  </table>

  <dot-loader [visibility]="loading()" [large]="true"></dot-loader>

  @if (isEditing()) {
    <div class="margin-top--2x">
      <button
        class="button primary"
        (click)="save()"
        [disabled]="regionForm.invalid"
      >
        Spara
      </button>
      <button class="link" (click)="cancelEditing()">Avbryt redigering</button>
    </div>
  }
</div>
